export const keyCodes = {
  BACKSPACE: 8,
  TAB: 9,
  ESC: 27,
  LEFTARROW: 37,
  RIGHTARROW: 39,
} as const
